import React from "react"

const selectedPlans = []

export const SelectedPlansContext = React.createContext(selectedPlans)
